<template>
  <section>
    <center>
      <div style="height: calc(50vh - 125px)"></div>

      <a href="https://rackon2.com/" target="_blank">
        <img style="width: 80%; max-width: 300px" src="@/assets/logo-rackon2-w-contorno-eq.svg" />
      </a>

      <span style="display: block; color: grey" class="title-1">Version 1.0</span><br>

      <div>
        <v-icon medium color="deep-purple lighten-5" >mdi-email</v-icon>&nbsp;
        <a href="mailto:rackon2.soporte@equinsa.es">rackon2.soporte@equinsa.es</a>
      </div><br/>


      <router-link 
        :to="{ name: 'PaginaCondicionesLegales', params: {tipoPagina: 0 } }"
        style="margin-left: 5px; margin-right: 5px;" class="mx-2_">
        <span style="color:silver; white-space:nowrap; font-size:13px">Términos y condiciones</span>
      </router-link><br>

      <router-link 
        :to="{ name: 'PaginaCondicionesLegales', params: {tipoPagina: 2 } }"
        style="margin-left: 5px; margin-right: 5px;" class="mx-2_">
        <span style="color:silver; white-space:nowrap; font-size:13px">Política de privacidad</span>
      </router-link><br/>
                  
      <span style="display: block; color: #E0E0E0" class="mt-15 mb-n1 caption">Powered by</span>
      <img style="width: 170px" src="@/assets/logo_equinsa_networking.png">

     </center>
  </section>
</template>

<script>
export default {
  name: "AcercaDe",
  data: () => ({}),

  methods: {},
};
</script>

<style scoped>
a { text-decoration: none; }
</style>